import contractVersioning from "./contractVersioning.component";

const contractVersioningModule = angular
  .module("app.components.contractVersioning", [])
  .component("contractVersioning", contractVersioning);

export default contractVersioningModule;



// WEBPACK FOOTER //
// ./src/components/contractVersioning/contractVersioning.module.js